import { render } from "./FirststepGroomingView.vue?vue&type=template&id=4667625c&scoped=true"
import script from "./FirststepGroomingView.vue?vue&type=script&lang=js"
export * from "./FirststepGroomingView.vue?vue&type=script&lang=js"

import "./FirststepGroomingView.vue?vue&type=style&index=0&id=4667625c&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4667625c"]])

export default __exports__